export default __webpack_public_path__ + "static/media/ic_perm_device_information_white_48px.2ba3ae96.svg";